var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tab',{attrs:{"title":"Custom Mentorship Activities","active":_vm.active,"lazy":""}},[_c('custom-activity-table',{attrs:{"activity-type":"MA"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }